import { Component, OnInit } from '@angular/core';
import {SmsService} from '../../services/sms-service';
import {SMSBalance, SMSMessage} from '../../models/sms.model';
import {BehaviorSubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DialogNewSiteComponent} from '../website-control-center/my-sites/dialogs/dialog-new-site/dialog-new-site.component';
import {HttpClient} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {DialogErrorComponent} from '../../dialogs/dialog-error/dialog-error.component';
import {Promotion} from '../../models/promotion.model';
import {DialogConfirmationComponent} from '../../dialogs/dialog-confirmation/dialog-confirmation.component';
import {DialogPredefinedSmsComponent} from './dialogs/dialog-predefined-sms/dialog-predefined-sms.component';

@Component({
  selector: 'app-streamup-sms-compose',
  templateUrl: './sms-compose.component.html',
  styleUrls: ['./sms-compose.component.scss']
})
export class SmsComposeComponent implements OnInit {

    loadingSmsAccountBalance$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    loadingSmsAccountHistory$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    smsAccountBalance$: BehaviorSubject<SMSBalance> = new BehaviorSubject<SMSBalance>(new SMSBalance('', '', -1));
    hasSMSes$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    SMSes$: BehaviorSubject<SMSMessage[]> = new BehaviorSubject<SMSMessage[]>([]);

    smsForm: FormGroup;


  constructor(
      private smsService: SmsService,
      private formBuilder: FormBuilder,
      public snackBar: MatSnackBar,
      private dialog: MatDialog
  ) { }

  ngOnInit(): void {
      this.createForm();
      this.getSmsAccountBalance();
      this.getRecentActivity();
  }

    createForm() {
        this.smsForm = this.formBuilder.group({
            originator: ['StreamUp', [Validators.required, Validators.maxLength(11)]],
            recipients: ['',  [Validators.required, Validators.pattern('[,0-9]*')]],
            message: ['', Validators.required],
            flash: [false]
        });
    }

    get f(){
        return this.smsForm.controls;
    }

    sendSMS(): void {
      this.smsService.sendSMS(this.smsForm.value.originator, this.smsForm.value.recipients, this.smsForm.value.message, this.smsForm.value.flash)
          .subscribe((response: any) => {
              if (!response.error){
                  this.snackBar.open('Message sent!!', null, {duration: 1000});
                  this.resetForm();
                  this.loadingSmsAccountHistory$.next(true);
                  setTimeout(() => {
                      this.getRecentActivity();
                      this.getSmsAccountBalance();
                  }, 3000);
              }else{
                  this.snackBar.open(response.message.information, null, {duration: 3000});
              }
          }, (errorResponse: any) => {
              this.handleError(errorResponse.error.message.information);
          });
  }

  getRecentActivity(){
      this.loadingSmsAccountHistory$.next(true);
      this.smsService.getSmsHistory()
          .subscribe((SMSes: SMSMessage[]) => {
              this.SMSes$.next(SMSes);
              this.hasSMSes$.next(SMSes.length > 0);
              this.loadingSmsAccountHistory$.next(false);
          });
  }

    getSmsAccountBalance(){
      this.loadingSmsAccountBalance$.next(true);
      this.smsService.getSmsAccountBalance()
          .subscribe((balance: SMSBalance) => {
              this.smsAccountBalance$.next(balance);
              this.loadingSmsAccountBalance$.next(false);
          });
    }

    showPredefinedSms(){
        return this.dialog
            .open(DialogPredefinedSmsComponent, {
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe(body => {
                if (body != null) {
                    this.smsForm.controls.message.patchValue(body);
                }
            });
    }

    handleError(errorInformation: string){
        return this.dialog
            .open(DialogErrorComponent, {
                data: {
                    error: errorInformation,
                },
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe();
    }

    resetForm(){
      this.smsForm.reset();
    }

}
